// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a23e9165","453":"52bb7489","455":"5da7efff","977":"dc5b2e41"}[chunkId] + ".chunk.js";
};